// Importation des Hooks React nécessaires et des données à partir d'un fichier de données
import React, { useState, useEffect } from "react";
import {
  competences,
  experiences,
  formations,
  languages,
  hobbies,
  technologies,
} from "../../Partials/Data/Data";
import { useTranslation } from 'react-i18next'; // Import pour la traduction

// Définition du composant Tabs
function Tabs() {
  const { t } = useTranslation(); // Initialisation de la fonction de traduction
  const [activeTab, setActiveTab] = useState(
    localStorage.getItem("activeTab") || "experiences"
  );

  useEffect(() => {
    localStorage.setItem("activeTab", activeTab);
  }, [activeTab]);

  const tabs = [
    { id: "experiences", name: t("tabs.experiences"), content: experiences },
    { id: "formations", name: t("tabs.formations"), content: formations },
    { id: "languages", name: t("tabs.languages"), content: languages },
    { id: "technologies", name: t("tabs.technologies"), content: technologies },
    { id: "competences", name: t("tabs.competences"), content: competences },
    { id: "hobbies", name: t("tabs.hobbies"), content: hobbies },
  ];

  return (
    <div id="about" style={{ minHeight: '80vh', width: '90%' }}>
      <video
        autoPlay
        loop
        muted
        style={{
          position: 'absolute',
          top: '0',
          left: '0',
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: '-1',
          borderRadius: '10px',
          pointerEvents: 'none' // Assure que la vidéo ne bloque pas les interactions
        }}
      >
        <source src="/images/videos/2611250-uhd_3840_2160_30fps.mp4" type="video/mp4" />
        Votre navigateur ne supporte pas la lecture vidéo.
      </video>
      <div
        className="containr"
        style={{
          zIndex: '1',
          // padding: '20px',
          boxShadow: '0 4px 6px 0 hsla(0, 0%, 0%, 0.2)',
          borderRadius: '10px',
        }}
      >
        <div className="row">
          <div className="about-col-1"></div>
          <div className="about-col-2">
            <h1 className="sub-title">{t("tabs.title")}</h1>
            <div className="tab-titles">
              {tabs.map((tab, index) => (
                <p
                  key={index}
                  className={`tab-links ${activeTab === tab.id ? "active-link" : ""}`}
                  onClick={() => setActiveTab(tab.id)}
                >
                  {tab.name}
                </p>
              ))}
            </div>

            {tabs.map((tab, index) => (
              <div
                key={index}
                className={`tab-contents ${activeTab === tab.id ? "active-tab" : ""}`}
                id={tab.id}
              >
                <ul>
                  {tab.content.map((item, index) => (
                    <li key={index}>
                      <span>{t(item.title)}</span>
                      <br />
                      <div dangerouslySetInnerHTML={{ __html: t(item.description) }} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Tabs;
